import type React from 'react';
import cx from 'clsx';
import Styles from './ConstructionList.module.scss';
import { ConstructionListRows } from '~/components/common/constructions/list/ConstructionListRows';
import type { ConstructionItem } from '~/models/ConstructionItem';
import type { NskResponse } from '~/models/Api';
import type {
  DealConstruction,
  DealConstructionContext,
  DealConstructionEdit
} from '~/models/DealConstruction';
import type { Deal } from '~/models/Deal';
import type { DealEstimationHeader } from '~/models/DealEstimationHeader';

type Props = {
  readonly: boolean;
  deal: Deal;
  constructionContext: DealConstructionContext;
  constructionItems: ConstructionItem[];
  companyType: 'client' | 'vendor' | 'partner';
  docType: 'billing' | 'estimation';
  showHighlight?: boolean;
  showEstimationConfirmedButton?: boolean;
  requestHeader?: DealEstimationHeader | null;
  handleMutateConstructions?: (() => Promise<void>) | null;
  handleUpdate?:
    | ((
        submitValue: DealConstructionEdit,
        estimationId: number | null,
        historyId: number | null
      ) => Promise<NskResponse<void>>)
    | null;
  handleDestroy?:
    | ((deleteConstruction: DealConstruction) => Promise<NskResponse<void>>)
    | null;
  handleUpdateSeq?:
    | ((constructions: DealConstruction[]) => Promise<void>)
    | null;
  handleUpdateEnabled?:
    | ((construction: DealConstruction) => Promise<void>)
    | null;
  target?: 'owner' | 'rentee' | null;
};
export const ConstructionList: React.FC<Props> = ({
  readonly,
  deal,
  constructionItems,
  constructionContext,
  companyType,
  docType,
  showHighlight = false,
  showEstimationConfirmedButton = false,
  requestHeader = null,
  handleMutateConstructions = null,
  handleUpdate = null,
  handleDestroy = null,
  handleUpdateSeq = null,
  handleUpdateEnabled = null,
  target = null
}: Props) => (
  <div>
    <table className={Styles.List}>
      <thead>
        <tr className={cx(Styles.ListRow, Styles.Header)}>
          <th className={Styles.OrderHandle}>
            {handleUpdateSeq !== null && <span>並替</span>}
          </th>
          {handleUpdateEnabled !== null && (
            <th className={Styles.SwitchEnable}>施工対象</th>
          )}
          <th className={Styles.Estimation}>施工項目</th>
          <th className={Styles.UnitAmount}>単価 * 数量</th>
          <th className={Styles.ChargePer}>負担割合</th>
          {target !== null && (
            <th className={Styles.ForAmount}>
              {target === 'rentee' && '入居者請求額'}
              {target === 'owner' && 'オーナー請求額'}
            </th>
          )}
          <th className={Styles.Amount}>価格</th>
          {!readonly && (
            <th className={Styles.Edit}>
              {handleUpdate !== null ||
                (handleDestroy !== null && <span>編集</span>)}
            </th>
          )}
        </tr>
      </thead>
      <ConstructionListRows
        companyType={companyType}
        constructionContext={constructionContext}
        constructionItems={constructionItems}
        deal={deal}
        docType={docType}
        handleDestroy={handleDestroy}
        handleMutateConstructions={handleMutateConstructions}
        handleUpdate={handleUpdate}
        handleUpdateEnabled={handleUpdateEnabled}
        handleUpdateSeq={handleUpdateSeq}
        readonly={readonly}
        requestHeader={requestHeader}
        showEstimationConfirmedButton={showEstimationConfirmedButton}
        showHighlight={showHighlight}
        target={target}
      />
    </table>
  </div>
);
